import Analytics from '@hh.ru/analytics-js';

import { EdProgramFilterId, EdProgramFilterItemKey } from 'src/types/EdProgram';

export type Goal = [string, string, string] | [string, string];

export const ExternalGoal: Record<string, Goal> = {
    // authorization
    click_authorization_login: ['click', 'authorization', 'login-in'],
    click_authorization_logout: ['click', 'authorization', 'login-out'],
    // common
    click_footer_become_partner: ['click', 'footer', 'become_partner'],
    click_footer_become_career_expert: ['click', 'footer', 'become_career_expert'],
    click_profession_guide_go_to_course: ['click', 'profession-guide', 'go-to-course'],
    click_block_compare_compare_your_salary: ['click', 'block-compare', 'compare-your-salary'],
    // main
    click_profession_main_page: ['click', 'profession', 'main_page'],
    send_feedback_submit: ['send', 'feedback', 'submit'],
    click_research_it_main_page: ['click', 'research', 'it_main_page'],
    click_banner_answer_and_know: ['click', 'banner', 'answer-and-know'],
    // profession_catalog
    click_profession_catalog_page: ['click', 'profession', 'catalog_page'],
    // professions page
    form_start_course_click: ['form', 'start_course', 'click'],
    form_start_course_submit: ['form', 'start_course', 'submit'],
    click_vacancy: ['click', 'vacancy'],
    click_profession_guide_tab_salary_vacancies: ['click', 'profession-guide', 'tab-salary-vacancies'],
    click_profession_guide_tab_calculator: ['click', 'profession-guide', 'tab-calculator'],
    click_profession_guide_tab_courses: ['click', 'profession-guide', 'tab-courses'],
    click_profession_guide_tab_career_track: ['click', 'profession-guide', 'tab-career-track'],
    // courses page
    click_header_courses_professions_skills: ['click', 'header', 'courses-professions-skills'],
    click_courses_all_courses: ['click', 'courses', 'all-courses'],
    click_courses_courses_by_professions: ['click', 'courses', 'courses-by-professions'],
    click_courses_courses_by_skills: ['click', 'courses', 'courses-by-skills'],
    input_courses_search: ['input', 'courses', 'search'],
    submit_courses_search: ['submit', 'courses', 'search'],
    // lk
    lk_clickButton_editLK: ['lk', 'clickButton', 'editLK'],
    lk_clickButton_editNaviki: ['lk', 'clickButton', 'editNaviki'],
    lk_inputRext_yourProffession: ['lk', 'inputRext', 'yourProffession'],
    lk_choose_grade: ['lk', 'choose', 'grade'],
    lk_clickButton_save: ['lk', 'clickButton', 'save'],
};

type ReachExternalEvent = (goal: Goal, params?: Record<string, string>) => void;

const reachExternalEvent: ReachExternalEvent = (goal, params): void => {
    try {
        const [category, event, label] = goal;
        Analytics.sendEvent(category, event, label, undefined, undefined, params);
    } catch (err) {
        console.error('ERROR: cannot send event', err);
    }
};

export const externalEvents = {
    reach: reachExternalEvent,
    reachClickCourseFilter(params: { key: EdProgramFilterItemKey; id: EdProgramFilterId; name: string }): void {
        const { key, id, name } = params;
        const goal: Goal = ['click', 'courses', key];
        return reachExternalEvent(goal, { [`${key}_filter`]: name, id });
    },
    reachInputCourseSearch(params: { search: string }): void {
        return reachExternalEvent(ExternalGoal.input_courses_search, params);
    },
    reachSubmitCourseSearch(params: { search: string }): void {
        return reachExternalEvent(ExternalGoal.submit_courses_search, params);
    },
};
